export const OTP_RATE_LIMIT_CODE = "RateLimitExceededException";
export const OTP_ALREADY_REGISTERED_CODE = "OTP.MOBILENUMBER";
export const OTP_UNKNOWN_USER_CODE = "OTP.UNKNOWN_CREDENTIAL";
export const OTP_VALIDATION_FAILED_CODE = "OTP.VALIDATION_UNSUCCESSFUL";
export const CAPTCHA_EXPIRED_CODE = "CAPTCHA_EXPIRED";

export const getOtpResponseData = (response) =>
  response?.data ?? response?.response?.data ?? null;

export const getOtpResponseStatus = (response) =>
  response?.status ?? response?.response?.status ?? null;

/** Zuul 429 uses Errors[]; user-otp 400 uses error.fields[]. */
export const extractApiErrorCode = (data) => {
  if (!data || typeof data !== "object") return null;

  const errors = data.Errors;
  if (Array.isArray(errors) && errors.length > 0) {
    const first = errors[0];
    if (first && typeof first === "object") {
      const code = first.code ?? first.errorCode;
      if (code != null) return String(code);
    }
  }

  const fields = data.error?.fields;
  if (Array.isArray(fields) && fields.length > 0) {
    const code = fields[0]?.code;
    if (code != null) return String(code);
  }

  const error = data.error;
  if (error && typeof error === "object") {
    const code = error.code ?? error.errorCode;
    if (code != null) return String(code);
  }

  const code = data.code ?? data.errorCode;
  return code != null ? String(code) : null;
};

export const extractApiErrorMessage = (data) => {
  if (!data || typeof data !== "object") return "";

  const errors = data.Errors;
  if (Array.isArray(errors) && errors.length > 0) {
    const msg = errors[0]?.message ?? errors[0]?.description;
    if (msg) return String(msg);
  }

  const fields = data.error?.fields;
  if (Array.isArray(fields) && fields.length > 0) {
    const msg = fields[0]?.message;
    if (msg) return String(msg);
  }

  const msg = data.error?.message ?? data.error_description ?? data.message;
  return msg != null ? String(msg) : "";
};

export const isOtpRateLimitResponse = (response) => {
  const status = getOtpResponseStatus(response);
  if (status === 429) return true;
  const data = getOtpResponseData(response);
  return extractApiErrorCode(data) === OTP_RATE_LIMIT_CODE;
};

export const isOtpAlreadyRegisteredResponse = (response) => {
  const data = getOtpResponseData(response);
  const code = extractApiErrorCode(data);
  if (code === OTP_ALREADY_REGISTERED_CODE) return true;
  return extractApiErrorMessage(data).includes("Already");
};

export const resolveOtpSendFieldErrorKey = (response) => {
  if (isOtpRateLimitResponse(response)) return "COMMON_MOBILE_RATE_LIMIT";
  if (isOtpAlreadyRegisteredResponse(response)) return "MOBILE_ALREADY_REGISTERED";
  return "COMMON_MOBILE_INVALID";
};

/** egov-otp has no EXPIRED code — expired vs wrong both return VALIDATION_UNSUCCESSFUL. */
export const resolveOtpVerifyMessageKey = (response) => {
  const data = getOtpResponseData(response);
  const code = extractApiErrorCode(data);
  if (code === OTP_VALIDATION_FAILED_CODE) return "ONBOARDING_OTP_INCORRECT";

  const message = extractApiErrorMessage(data);
  if (message.includes("OTP validation unsuccessful")) return "ONBOARDING_OTP_INCORRECT";

  return null;
};

export const isCaptchaExpiredResponse = (response) =>
  extractApiErrorCode(getOtpResponseData(response)) === CAPTCHA_EXPIRED_CODE;
